/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceAdmDenikSslSpisovyUzel extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceAdmDenikSslSpisovyUzelObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmDenikSslSpisovyUzelReadDto[];
        private keys: string[];

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceAdmDenikSslSpisovyUzelObj())
            this.hromadnaOperaceObj.createBase({
                title: "jres:33000616", //RC 33000616 : Hromadné přiřazení spisových uzlů
                data: this.data,
                objectFields: (this.hromadnaOperaceObj.openFromSpisUzel == true) ? ['ixs_su_txt'] : ['sslden'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceAdmDenikSslSpisovyUzel",
                keys: this.keys,
                contentId: "hromadnaOperaceAdmDenikSslSpisovyUzel "
            })
        }
    }

    export class HromadnaOperaceAdmDenikSslSpisovyUzelObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmDenikSslSpisovyUzelReadDto> {
        openFromSpisUzel: boolean;

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
            if (this.openFromSpisUzel == false) {
                form.addRow("jres:33000100").addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                    name: "sslden",
                    model: "model.sslden=value.sslden",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    initialValue: this.options.data.map((value) => ({ sslden: value.sslden })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    serverFilters: {
                        PouzeUzivatelskeDeniky: false,
                        aktivita: this.getAllAktivita()
                    }
                }).addRow("jres:33000091").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), {
                    name: "ixs_su",
                    model: "model.ixs_su=value.ixs_su;model.ixs_su_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            } else {
                form.addRow("jres:33000091").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), {
                    name: "ixs_su",
                    model: "model.ixs_su=value.ixs_su;model.ixs_su_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    initialValue: this.options.data.map((value) => ({ ixs_su: value.ixs_su })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                }).addRow("jres:33000100").addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                    name: "sslden",
                    model: "model.sslden=value.sslden",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    serverFilters: {
                        PouzeUzivatelskeDeniky: false,
                        aktivita: this.getAllAktivita()
                    }
                })
            }                    
            form.addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                    initialValue: { aktivita: 100 },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        createDefineGridData(formData: any): any {
            var cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["sslden"]), this.transformDataToArrayObject(formData, ["ixs_su", "ixs_su_txt"]));
            var resultArray: any = [];
            cartesianResult.forEach((item) => {
                var data = {
                    sslden: item[0]["sslden"],
                    ixs_su: item[1]["ixs_su"],
                    ixs_su_txt: item[1]["ixs_su_txt"],
                    aktivita: formData['aktivita']
                }
                resultArray.push(data);
            })
            return resultArray;
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            this.createAktivitaColumn(gridFormat);
            gridFormat.addTextColumn({
                caption: "jres:29808057",
                name: "sslden"
            }).addTextColumn({
                caption: "jres:33000091",
                name: "ixs_su_txt"
            })
            return gridFormat;
        }

        // Volání zatím přes CSharp (přes ISL zatím nevím jak na hromadné operace)
        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmDenikSslSpisovyUzelSaveDto[] = [];
            data.forEach((item) => {
                saveData.push({
                    sslden: item['sslden'],
                    ixs_su: item['ixs_su'],
                    subrada: item['subrada'],
                    aktivita: item['aktivita'],
                    NewRecord: true
                })
            })
            return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                this.createResultData(results)
            })
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return $.Deferred();
        }
    }
}